import { Button } from 'primereact/button';
import React from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Card as PrimeCard } from 'primereact/card';
import '../pages/backPricing.scss';

export default function BackPrimeCard({
  title,
  description,
  price,
  priceText,
  checklistP,
  buttonLabel,
  icon,
  keyFeature,
  headerStyle,
}) {
  const history = useHistory();

  return (
    <div className="col-12 sm:col-12 md:col-6 lg:col-6 xl:col-4">
      <PrimeCard>
        <div className="card_top_conatiner flex flex-column align-items-center">
          <div>
            <img alt="icon" src={icon} />
          </div>
          <div className={headerStyle}>
            <span>{title}</span>
          </div>
          <div className="card-underHeader">
            <p>{description} </p>
          </div>
        </div>
        <div className="card-price">
          <span>{priceText}</span>
        </div>
        <Button
          className="btn-magenta"
          label={buttonLabel}
          onClick={() => {
            if (buttonLabel === 'Get started') {
              history.push('/checkout', { data: { title, price, priceText, icon, checklistP } });
            } else {
              window.location.href = `https://www.upshow.tv/get-a-demo/`;
            }
          }}
        />
        <div className="bottom_container flex flex-column">
          <div id="text-mark">
            <div className="pi">
              <div className="keyFeature"> {keyFeature} </div>
              {checklistP.map(check => (
                <div key={check} className="textmark">
                  <div className="check_list align-items-center">
                    <i className="pi pi-check p-mr-2" />
                    <p>{check}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </PrimeCard>
    </div>
  );
}

BackPrimeCard.propTypes = {
  checklistP: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  priceText: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  headerStyle: PropTypes.string,
  keyFeature: PropTypes.string.isRequired,
  price: PropTypes.number,
};

BackPrimeCard.defaultProps = {
  headerStyle: 'card-header',
  price: undefined,
};
